export interface IWebSetting {
    sync_key: string;
    sync_last: string;
    web_setting_id: string;
    web_setting_value: string;
}
